import * as React from 'react';
import { Toast } from 'primereact/toast';
import ConnectedApps from '../../components/settings/ConnectedApps';

export default function Settings() {
    const toast = React.useRef(null);

    const displayToast = (msg) => {
        toast.current.show(msg);
    }

    return (
        <div>
            <Toast ref={toast} />
            <ConnectedApps displayToast={displayToast} />
        </div>
    )
}
